export default __webpack_public_path__ + "static/media/xoay.291e2c72.png";